<template>
    <div class="explainDetail">
        <div class="title" :style="{color:articleData.title_color}">{{ articleData.title }}</div>
        <div class="Subheading">
            <div class="time" style="margin-right:40px;">上传日期:{{ articleData.add_time*1000 | dateFormat('YYYY-MM-DD hh:mm:ss') }}</div>
            <div class="access_count">浏览次数:{{ articleData.access_count }}</div>
        </div>
        <pre v-html="articleData.content" class="ue">
        </pre>
    </div>
</template>

<style lang="scss" scoped>
    .explainDetail{
        width: 938px;
        overflow: auto;
        .title{
            font-size: 15px;
            width: 100%;
            text-align: center;
            font-size: 34px;
        }
        .Subheading{
            display: flex;
            flex-direction: row;
            justify-content: center;
            font-size: 15px;
            color: #999;
            margin-top: 8px;
            margin-bottom: 60px;
        }
    }
</style>

<script>
import { ArticleService } from '../../../service/article.service'
export default {
    data() {
        return {
            articleData: '',
            articleId:''
        }
    },
    watch: {
        $route() {
            this.articleId = this.$router.currentRoute.params.detailId 
            this.getArticle()
        }
    },
    methods: {
        async getArticle() {
            const data = await ArticleService.articleDetail(this.articleId)
            this.articleData = JSON.parse(JSON.stringify(data))
        }
    },
    created() {
        this.articleId = this.$router.currentRoute.params.detailId 
        this.getArticle()
    }
}
</script>